import { useState } from "react";
import Breadcrumb from "../../../Components/Common/Breadcrumb";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { simulatorTabsData } from "../../../data/SidebarData";
import Tabs from "../../../Components/Common/Tabs";
import Modal from "../../../Components/Common/Modal";
import { modelTestUrls } from "../../../Api/Auth/ApiUrls";
import {
  sendPostRequestAuth,
  sendPutRequestAuth,
} from "../../../Api/swrConfig";
import { toast } from "react-toastify";
import useSWRMutation from "swr/mutation";
import useTable from "../../../hooks/useTable";
import QueryString from "qs";
import useSWR from "swr";
import useToastError from "../../../hooks/useErrorToast";
import Table from "../../../Components/Common/Table";
import TableHead from "../../../Components/Common/TableHead";
import NoData from "../../../Components/Common/NoData";
import { Loader } from "../../../Components/Common/Loader";
import ModelTestRow from "./Components/ModelTestRow";
import Pagination from "../../../Components/Common/Pagination/Pagination";
import { useLocation } from "react-router-dom";
import ModelTestForm from "./Components/ModelTestForm";

const tableColumnData = [
  { id: "title", label: "Title" },
  { id: "price", label: "Price" },
  { id: "maxAttempts", label: "Max Attempt(s)" },
  { id: "createdAt", label: "Created" },
];

const ModelTestList = () => {
  const [row, setRow] = useState(null);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: 0,
    category: null,
    duration: "",
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const { showErrorToast } = useToastError();
  const location = useLocation();

  const actionButtons = [
    {
      label: "Create",
      icon: faAdd,
      onClick: () => {
        setRow(null);
        setFormData({
          title: "",
          description: "",
          price: 0,
          category: null,
          duration: "",
        });
        setModalOpen(true);
      },
    },
  ];

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    useTable({ defaultOrderBy: "" });
  const apiQueryParams = {
    offset: (page - 1) * rowsPerPage,
    limit: rowsPerPage,
  };
  const apiQueryString = QueryString.stringify(apiQueryParams);

  const { isLoading, data, mutate } = useSWR(
    modelTestUrls.list(apiQueryString)
  );

  const handleInputChange = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Set only the field that's changed
    }));
  };

  const { trigger, isMutating } = useSWRMutation(
    modelTestUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );
  const { trigger: EditTrigger, isMutating: editMutating } = useSWRMutation(
    modelTestUrls.edit(row?._id),
    sendPutRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        mutate();
        setModalOpen(false);
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const onEditClick = (row) => {
    setRow(row);
    handleInputChange("title", row.title);
    handleInputChange("description", row.description);
    handleInputChange("category", row.category);
    handleInputChange("price", row.price);
    handleInputChange("duration", row.duration);
    handleInputChange("maxAttempts", row.maxAttempts);
    handleInputChange("visible", row.visible);
    setModalOpen(true);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.maxAttempts)
      newErrors.maxAttempts = "Max attempts is required";
    if (!formData.category) newErrors.title = "Category is required";
    if (!formData.duration) newErrors.duration = "Duration is required";
    if (!formData.price && formData.price !== 0)
      newErrors.price = "Price is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const modifiedData = {
      ...formData,
      category:
        typeof formData.category === "object"
          ? formData.category.value
          : formData.category,
    };
    row ? EditTrigger(modifiedData) : trigger(modifiedData);
  };
  return (
    <div>
      <Breadcrumb actionButtons={actionButtons} />
      <Tabs tabs={simulatorTabsData} />
      <Table>
        <TableHead rowCount={data?.data.length} headerData={tableColumnData} />
        <tbody className={`divide-y divide-gray-200`}>
          {!isLoading ? (
            <>
              {data?.data.map((row) => (
                <ModelTestRow
                  key={row._id}
                  row={row}
                  mutate={mutate}
                  onEditClick={onEditClick}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="100" className="text-center py-4">
                <Loader />
              </td>
            </tr>
          )}
        </tbody>
        <NoData isNotFound={!data?.data.length && !isLoading} />
      </Table>
      <Pagination
        totalRows={data?.pagination.totalItems || 0}
        currentPage={page}
        rowsPerPage={rowsPerPage}
        currentPath={location.pathname}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Modal
        isOpen={isModalOpen}
        title={row ? "Edit Model Test" : "Create Model Test"}
        onConfirm={handleSubmit}
        onCancel={() => {
          setErrors({});
          setModalOpen(false);
        }}
        isLoading={isMutating || editMutating}
        formWidth
      >
        <ModelTestForm
          errors={errors}
          handleSubmit={handleSubmit}
          onChange={handleInputChange}
          formData={formData}
        />
      </Modal>
    </div>
  );
};

export default ModelTestList;
